// -----------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------

export const NAME = 'dfbAlert'
const CLASS = 'dfb-Alert'

export const ClassName = {
  ROOT: CLASS,
  MESSAGE: `${CLASS}-message`,
  CLOSE: `${CLASS}-closeButton`
}

export const Selector = {
  ROOT: `.${ClassName.ROOT}`,
  MESSAGE: `.${ClassName.MESSAGE}`,
  CLOSE: `.${ClassName.CLOSE}`
}

export const States = {
  VISIBLE: `is-visible`
}

export const Event = {
  CLICK: `click`
}

export const AutoClose = {
  DURATION: 5000
}
